import { createFocusTrap, FocusTrap } from 'focus-trap';
import { on } from 'delegated-events';
import createFloatingWithArrow from '../../../javascripts/utils/createFloatingWithArrow';
import abort from '../../../javascripts/utils/abort';
import moveFocus from '../../../javascripts/utils/moveFocus';

let focusTrap: FocusTrap | null = null;
let cleanup: () => void;

on('click', 'button.copyright__button', async (event) => {
  const { currentTarget: $button } = event;
  const $copyright = $button.closest<HTMLDivElement>('.copyright') ?? abort();

  event.preventDefault();

  if (focusTrap) {
    focusTrap.deactivate();
  } else {
    const $floating = $copyright?.querySelector<HTMLDivElement>('.copyright__floating') ?? abort();
    const $portal = document.getElementById('portal') ?? document.body;

    $floating.hidden = false;
    $portal.appendChild($floating);

    focusTrap = createFocusTrap($copyright, {
      onDeactivate() {
        $floating.hidden = true;
        $copyright.appendChild($floating);
        cleanup?.();
        $button.classList.remove('copyright__button--active');
        $button.setAttribute('aria-pressed', 'false');
        moveFocus($button);
        focusTrap = null;
      },
      async onActivate() {
        cleanup = await createFloatingWithArrow({ $floating, $reference: $button });
        $button.classList.add('copyright__button--active');
        $button.setAttribute('aria-pressed', 'true');
        moveFocus($floating);
      },
      initialFocus: false,
      clickOutsideDeactivates: (e: MouseEvent | TouchEvent) => (
        e.target instanceof HTMLElement ? !$floating.contains(e.target) : false
      ),
      returnFocusOnDeactivate: false,
      preventScroll: false,
    });

    focusTrap.activate();
  }
});
